import React, {Component} from 'react'
import {Row} from 'antd'

class TableHeader extends Component {
  render() {
    return (
      <Row style={{marginBottom: 10, marginTop: 10}}>{this.props.children}</Row>
    )
  }
}

TableHeader.propTypes = {}
TableHeader.defaultProps = {}

export default TableHeader
